import FormattedMessage from 'I18n/components/FormattedMessage';
import ToolChiclet from 'ai-components-ui-library/components/chiclets/ToolChiclet';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function SkillsList({
  skills
}) {
  return /*#__PURE__*/_jsxs(Flex, {
    flexDirection: "column",
    gap: "100",
    children: [/*#__PURE__*/_jsx(Text, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "detailsPage.functionalityCard.tabs.skills.description"
      })
    }), /*#__PURE__*/_jsx(Flex, {
      flexDirection: "column",
      gap: "100",
      children: skills.map(skill => {
        var _skill$customImage;
        return /*#__PURE__*/_jsx(ToolChiclet, {
          text: skill.title,
          onClick: () => {},
          "data-test-id": skill.title,
          iconUrl: (_skill$customImage = skill.customImage) === null || _skill$customImage === void 0 ? void 0 : _skill$customImage.imageSrc
        }, skill.title);
      })
    })]
  });
}